var _rect, _rect2, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkRoundLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 52,
    height: 52,
    rx: 26,
    fill: "url(#paint0_linear_4331_3051)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 52,
    height: 52,
    rx: 26,
    stroke: "white",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2639 20.9134C37.7704 17.0554 33.4353 14.5 28.501 14.5C20.7688 14.5 14.5015 20.7672 14.5015 28.4991C14.5015 29.4659 14.5989 30.4104 14.786 31.3232C26.703 23.8099 36.2569 21.5641 40.2639 20.9134Z",
    fill: "#40C1AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5517 21.3762C28.7611 26.475 21.0303 35.2686 18.5631 38.3614C21.1001 40.9167 24.6145 42.5 28.499 42.5C36.2311 42.5 42.4985 36.2315 42.4985 28.4996C42.5012 25.8968 41.7885 23.4626 40.5517 21.3762Z",
    fill: "#40C1AC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4331_3051",
    x1: 28.5,
    y1: 0.5,
    x2: 28.5,
    y2: 56.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26283B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#2C5364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151833"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkRoundLogo);
export default __webpack_public_path__ + "static/media/dark-round-logo.e2a3b55a971556a0fe56971e2d60c2b0.svg";
export { ForwardRef as ReactComponent };